import React, {useState, useEffect} from 'react';
import { Modal, Button, ModalHeader } from "react-bootstrap";
import { useTheme } from "@mui/material";
import { tokens } from "../../../../../../theme";


const Feedback: React.FC<{
    feedbackModal: any;
    setFeedbackModal: any;
    feedbackGreet: any;
    setFeedbackGreet: any
  }> = ({feedbackModal, setFeedbackModal, feedbackGreet, setFeedbackGreet}) => {

    const [response, setResponse] = useState<string>("");

    const theme = useTheme(); // Access the current theme
    const colors = tokens(theme.palette.mode);
    let color = theme.palette.mode;
    const handleClose = () => setFeedbackModal(!feedbackModal);
    

    const handleResponse = (event:React.ChangeEvent<HTMLTextAreaElement>) => {
      setResponse(event.target.value);
    }
    
    const handleSubmit = () =>{
      handleClose();
      setFeedbackGreet(!feedbackGreet);
      console.log("Dislike: " + response);
    }
  
  
    useEffect(() => {
      // Set CSS variables based on the current theme colors
      document.documentElement.style.setProperty(
        "--header-bg-color",
        colors.headers.backround
      );
      document.documentElement.style.setProperty(
        "--header-text-color",
        colors.headers.text
      );
      document.documentElement.style.setProperty(
        "--box-shadow",
        colors.headers.boxShadow
      );
    }, [theme]);
  
    return (
      <>
        <Modal
          show = {feedbackModal}
          onHide={handleClose}
          data-bs-theme={color}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          // style={{padding: '0px !important'}}
        >


          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
          </Modal.Header>
          
          <Modal.Body style={{ margin: 0 }}>

            <h5
                style={{
                  color: "var(--header-text-color)",
                  marginBottom: "12px",
                }}
              >
                Provide Your Feedback
              </h5>
            
              <>
                <textarea placeholder='Enter your feedback' onChange={handleResponse} value = {response} required></textarea>
              </>
            
          </Modal.Body>

          <Modal.Footer style={{ justifyContent: "flex-end" }}>
            <button
              className="submitFeedback"
              style={{ width: "fit-content" }}
              onClick={handleSubmit}
            >
              Submit
            </button>
          </Modal.Footer>
        </Modal>

      </>

    );
  };

  export default Feedback;
  